import * as React from 'react';
import * as styles from './LockMenuItem.scss';
import { observer } from 'mobx-react-lite';
import { Toggle, IToggleStyles } from '@fluentui/react/lib/Toggle';
import { setAssetsLock } from 'owa-timestream-asset-sdk-actions';
import { isAssetsLocked } from 'owa-timestream-canvas';
import loc from 'owa-localize';
import { lockAssetsMenuItemLabel } from './getLockAssetsMenuItem.locstring.json';
import { toggleBoardLockAssetsTooltip } from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';

const LockAssetsToggleStyles: Partial<IToggleStyles> = {
    root: styles.lockMenuRoot,
    label: styles.lockMenuText,
};

export default observer(function LockAssetsMenuItem() {
    const isLocked = isAssetsLocked();

    return (
        <TooltipHost content={isLocked ? undefined : loc(toggleBoardLockAssetsTooltip)}>
            <Toggle
                styles={{
                    ...LockAssetsToggleStyles,
                    ...(isLocked
                        ? {}
                        : { pill: styles.lockAssetsContent, thumb: styles.lockMenuContent }),
                }}
                checked={isLocked}
                onChange={onToggle}
                label={loc(lockAssetsMenuItemLabel)}
                inlineLabel={true}
            />
        </TooltipHost>
    );
});
function onToggle(ev: React.MouseEvent<HTMLElement>, checked?: boolean) {
    setAssetsLock(!!checked);
}
